import axios from 'axios'
import qs from 'qs'
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from '../../urlLink'
import {isGraySchoolEnabled} from "@/bootstrap/graySchoolRouting";
const root = Urls.crmApiUrl //域名
//首页数据请求
const url = {
  lossInvalidExamineAction:root+"/Lossclient/lossInvalidExamineAction",
  getLossclient:root+"/Lossclient",
  getInvalidClientList:root+"/Lossclient/getInvalidClientList",
  getInvalidClientListExport:root+"/Lossclient/getInvalidClientList/Export",
  changeLossClientTmkApi:root+"/Lossclient/changeLossClientTmkApi",
  getSource:root+"/Public/getSourceApi",
  changeLossClient:root+"/Lossclient/changeLossClientApi",
  changeLossIntention:root+"/Lossclient/changeLossIntentionApi",
  lossExamine:root+"/Lossclient/lossExamineAction",
  toEffectiveAction:root+"/Lossclient/toEffectiveAction",
  ExceedAge:root+"/ExceedAge",
  ExceedAgeExport:root+"/ExceedAge/Export",
  getExceedAgeApi:root+"/ExceedAge/getExceedAgeApi",//超龄名单 ->超龄日期
  addExceedAgeAction:root+"/ExceedAge/addExceedAgeAction",//超龄名单 ->添加超龄日期 
  updateExceedAgeAction:root+"/ExceedAge/updateExceedAgeAction",//超龄名单 ->编辑超龄日期
  delExceedAgeAction:root+"/ExceedAge/delExceedAgeAction",//超龄名单 ->删除超龄日期
  getAllSchoolApi:root+"/Api/getAllSchoolApi",//获取转校学校列表-lujing龄日期
  transferEAClientSchoolAction:root+"/ExceedAge/transferEAClientSchoolAction",//超龄名单转校-lujing
}
const storeLosscustomerManage=  {
  //无意向客户管理首页
  getLossclient(params){
    return axios.get(url.getLossclient,{ params })
  },
  changeLossClientTmkApi(params){
    return axios.post(url.changeLossClientTmkApi,qs.stringify(params))
  },
  lossInvalidExamineAction(params){
    return axios.post(url.lossInvalidExamineAction,qs.stringify(params))
  },
  //无意向客户管理首页---导出
  getLossclient1(){
    return url.getLossclient
  },
  // 无效客户管理
  getInvalidClientList(params){
    return axios.get(url.getInvalidClientList,{ params })
  },
  //无效客户管理---导出
  getInvalidClientList1(){
    return isGraySchoolEnabled() ? url.getInvalidClientListExport: url.getInvalidClientList
  },
  //超龄名单 ->超龄名单列表
  ExceedAge(params){
    return axios.get(url.ExceedAge,{ params })
  },
  //超龄名单 ->超龄名单列表--导出
  ExceedAge1(){
    return isGraySchoolEnabled() ? url.ExceedAgeExport: url.ExceedAge
  },
  // 超龄名单 ->超龄日期
  getExceedAgeApi(params){
    return axios.get(url.getExceedAgeApi,{ params })
  },
  // 超龄名单 ->添加超龄日期 
  addExceedAgeAction(params){
    return axios.post(url.addExceedAgeAction,qs.stringify(params))
  },
  // 超龄名单 ->编辑超龄日期 
  updateExceedAgeAction(params){
    return axios.post(url.updateExceedAgeAction,qs.stringify(params))
  },
  // 超龄名单 ->删除超龄日期 
  delExceedAgeAction(params){
    return axios.post(url.delExceedAgeAction,qs.stringify(params))
  },
  // 获取招生渠道类型
  getSource(params){
    return axios.get(url.getSource,{ params })
  },
  // 无意向客户管理->转为招生线索或无意向
  changeLossClient(params){
    return axios.post(url.changeLossClient,qs.stringify(params))
  },
  // 无意向客户管理->转为意向客户
  changeLossIntention(params){
    return axios.post(url.changeLossIntention,qs.stringify(params))
  },
  // 无意向客户->无意向客户审核
  lossExamine(params){
    return axios.post(url.lossExamine,qs.stringify(params))
  },
  // 无意向客户->无效名单转为有效名单
  toEffectiveAction(params){
    return axios.post(url.toEffectiveAction,qs.stringify(params))
  },
  //侯小草2020-2-28 新增
  // 获取转校学校列表-lujing龄日期
  getAllSchoolApi(params){
    return axios.get(url.getAllSchoolApi,{ params })
  },
  // 超龄名单转校-lujing
  transferEAClientSchoolAction(params){
    return axios.post(url.transferEAClientSchoolAction,qs.stringify(params))
  },
}

export default storeLosscustomerManage;